/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investmentNeedBurnComponentDtoSchema = z.object({
  component: z.optional(z.string()),
  monthlyBurn: z.optional(z.string()),
  share: z.optional(z.string()),
});
